//@ts-nocheck
import { ApplicationFormModalProps } from "@/_new_/pages/home-page/sections/ApplicationFormModal.types";
import {
  Box,
  BoxProps,
  Button,
  Center,
  Flex,
  Link,
  Stack,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useScreenWidth } from "../../helpers/useScreenWidth";
import { HowItWorksVideoModal } from "../../pages/components/overlays/HowItWorksVideoModal";
import { ButtonPrompt } from "../ButtonPrompt";
import { useHashDisclosure } from "../navbar/components/NavSearch/components/SearchLikeButton/hooks";
import ApplicationButton from "./ApplicationButton";
import { CarouselSliderProps } from "./CarouselSlider.types";
import {
  CarouselSlide,
  CarouselSlideActions,
  CarouselSlideHeading,
  CarouselSlideSubheading,
  CarouselSliderPrompt,
} from "./carousel-slider";
import { ImageComponent } from "./shared-image";

function LinkOrModal({
  children,
  ...rest
}: ApplicationFormModalProps & {
  children?: any;
}) {
  return (
    <ApplicationButton
      applicationProps={rest}
      size={useBreakpointValue({ base: "lg", md: "md", lg: "lg" })}
      minW={{ base: "100%", md: "2xs" }}
      colorScheme="yellow"
      height={{
        base: "14",
        md: "12",
        lg: "14",
      }}
    >
      {children}
    </ApplicationButton>
  );
}

export const CarouselSlider = (
  props: CarouselSliderProps &
    BoxProps & {
      applicationFormProps?: ApplicationFormModalProps;
    }
) => {
  const modal = useHashDisclosure("how-it-works");
  const {
    backgroundImgUrl,
    heading,
    subHeading,
    destinationUrl,
    converted = false,
    title,
    name,
    tutorReviews,
    sliderImageAlt,
    buttonText,
    buttonPrompt,
    sliderImgUrl,
    ImgComponent = ImageComponent,
    Link: LinkComponent = Link,
    applicationFormProps,
    ...rest
  } = props;
  const { isLargeTab } = useScreenWidth();

  const LinkC = converted ? LinkComponent : Link;
  return (
    <>
      <CarouselSlide
        shadow={{ base: "none", lg: "2xl" }}
        className="keen-slider__slide"
        {...rest}
        backgroundImage={backgroundImgUrl}
      >
        <Flex
          pb={{ lg: 16 }}
          gap={{ base: 12, md: 16, lg: isLargeTab ? 16 : 32 }}
          boxSize="full"
          justify="space-between"
          direction={{ base: "column", md: "row" }}
          align={{ base: "flex-start", md: "center" }}
        >
          <Stack
            spacing={{ base: 10, lg: 12 }}
            maxW={{ md: "xl", lg: "lg" }}
            width={{ md: "100vw", lg: "100vw" }}
            height="fit-content"
            className="carousel__slide--content"
            flex={1.5}
          >
            <Stack spacing={{ base: 5, md: 6 }}>
              <CarouselSliderPrompt>{title}</CarouselSliderPrompt>
              <CarouselSlideHeading>{heading}</CarouselSlideHeading>
              <CarouselSlideSubheading>{subHeading}</CarouselSlideSubheading>
            </Stack>
            <CarouselSlideActions>
              {converted && applicationFormProps ? (
                <LinkOrModal {...applicationFormProps}>
                  {buttonText}
                </LinkOrModal>
              ) : (
                <LinkC
                  width={{ base: "full", md: "auto" }}
                  aria-label={`${name}-button`}
                  href={destinationUrl}
                  _hover={{ textDecoration: "none" }}
                >
                  <Button
                    size={useBreakpointValue({
                      base: "lg",
                      md: "md",
                      lg: "lg",
                    })}
                    minW={{ base: "100%", md: "2xs" }}
                    colorScheme="yellow"
                    height={{
                      base: "14",
                      md: "12",
                      lg: "14",
                    }}
                  >
                    {buttonText}
                  </Button>
                </LinkC>
              )}
              {buttonPrompt?.display ? (
                <Box>
                  <ButtonPrompt onClick={modal.onOpen} {...buttonPrompt} />
                </Box>
              ) : null}
            </CarouselSlideActions>
          </Stack>
          <Center flex={1} rounded="fbRadius" overflow="hidden">
            <ImgComponent
              boxSize="100%"
              objectFit="contain"
              src={sliderImgUrl}
              alt={sliderImageAlt}
            />
          </Center>
        </Flex>
      </CarouselSlide>
      {buttonPrompt?.display && buttonPrompt.videoData && (
        <HowItWorksVideoModal
          isOpen={modal.isOpen}
          onClick={() => (window.location.href = buttonPrompt.href)}
          onClose={modal.onClose}
          tutorReviews={tutorReviews}
          {...buttonPrompt?.videoData}
        />
      )}
    </>
  );
};
